<span class="icon"><app-icon [name]="icon()" /></span>
<p class="text">{{ message().message }}</p>
<button type="button" class="close" (click)="messageService.hide(message().id)" [attr.aria-label]="'messages.close' | translate">
    <app-icon name="x-mark" />
</button>
<span class="progress" [style.transform]="'scaleX(' + remaining() + ')'"></span>
